import React from 'react';
import Detection from './Detection';
import { LPRParamList } from '../../../typings/Params';
import { useRoute, RouteProp } from '@react-navigation/native';
import { RootNavigation } from '../../../Routes';

interface DetectionProps {
    navigation: RootNavigation;
}

export default function LiveEventLprDetection({ navigation }: DetectionProps) {
    const route = useRoute<RouteProp<LPRParamList, 'LiveEventLprDetection'>>();
    return <Detection navigation={navigation} route={route} page={'live-events'} />;
}
